
import * as type from './types';

export function getChat(data) {
    return {
        type: type.GET_CHAT_DATA_REQUESTED,
        data: data,
    }
};